import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class FormValidation {
  
  constructor() { }


  isValidField(form: FormGroup,name: string): boolean {
    const control = form.get(name);
    return control ? control.valid && (control.dirty || control.touched) : false;
  }

  isInvalidField(form: FormGroup,name: string): boolean {
    const control = form.get(name);
    return control ? control.invalid : false;
  }

  getErrorMessage(form: FormGroup,name:string): string | null {
    const control = form.get(name);
    
    if (control && control.errors) {
      if (control.errors['required']) {
        return 'This field is required';
      } else if (control.errors['email']) {
        return 'The email is not valid';
      }else if (control.errors['maxlength']) {
        return `The maximum size for this field is ${control.errors['maxlength'].requiredLength} characters`;
      }else if (control.errors['minlength']) {
        return `The minimun size for this field is ${control.errors['minlength'].requiredLength} characters`;
      }else{
        return 'This field is invalid';
      }
    }
    return null;
  }

  getErrorComparePassword(form: FormGroup): string | null {
    const control = form.errors;
    if (control && control["passwordsNotMatch"]) {
      return "Passwords don't match"      
    }
    return null;
  }

  getErrorFilePDF(form: FormGroup): string | null {
    const control = form.errors;
    if (control && control["pdfFile"].error=="fileType") {
      return 'Invalid file type. Only PDF files are allowed.'; 
    }else if (control && control["pdfFile"].error=="fileSize") {
      return  'The file is too large. Maximum size allowed is 2 MB.'; 
    }
    return null;
  }


}
